import { GlBadge, GlDisclosureDropdown, GlDisclosureDropdownItem, GlSkeletonLoader, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, s__ } from '~/locale';
import getOpenMrCountForBlobPath from '~/repository/queries/open_mr_count.query.graphql';
import getOpenMrsForBlobPath from '~/repository/queries/open_mrs.query.graphql';
import { nDaysBefore } from '~/lib/utils/datetime/date_calculation_utility';
import { formatDate } from '~/lib/utils/datetime/date_format_utility';
import { logError } from '~/lib/logger';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { InternalEvents } from '../../../tracking/index.js?vue3';
import MergeRequestListItem from './merge_request_list_item.vue?vue3';
const OPEN_MR_AGE_LIMIT_DAYS = 30;
const STALE_TAB_ERROR_MESSAGE = 'createdAfter must be within the last 30 days';
const SENTRY_OPTIONS = {
    tags: {
        feature_category: 'source_code_management'
    }
};
export default {
    name: 'OpenMrBadge',
    components: {
        GlBadge,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlSkeletonLoader,
        MergeRequestListItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        projectPath: {
            type: String,
            required: true
        },
        blobPath: {
            type: String,
            required: true
        },
        currentRef: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            openMrsCount: null,
            openMrs: [],
            isDropdownOpen: false
        };
    },
    computed: {
        badgeTitle () {
            return s__('OpenMrBadge|Open merge requests created in the past 30 days that target this branch and modify this file.');
        },
        openMRsCountText () {
            return sprintf(s__('OpenMrBadge|%{count} Open'), {
                count: this.openMrsCount
            });
        },
        createdAfter () {
            const lookbackDate = nDaysBefore(new Date(), OPEN_MR_AGE_LIMIT_DAYS - 1, {
                utc: true
            });
            return formatDate(lookbackDate, 'yyyy-mm-dd HH:MM:ss Z', true);
        },
        isLoading () {
            return this.$apollo.queries.loading;
        },
        showBadge () {
            return !this.isLoading && this.openMrsCount > 0;
        },
        queryVariables () {
            return {
                projectPath: this.projectPath,
                targetBranch: [
                    this.currentRef
                ],
                blobPath: this.blobPath,
                createdAfter: this.createdAfter
            };
        }
    },
    apollo: {
        openMrsCount: {
            query: getOpenMrCountForBlobPath,
            variables () {
                return this.queryVariables;
            },
            update (data) {
                return data?.project?.mergeRequests?.count;
            },
            result () {
                if (this.openMrsCount > 0) {
                    this.trackEvent('render_recent_mrs_for_file_on_branch_badge', {
                        value: this.openMrsCount
                    });
                }
            },
            error (error) {
                logError(`Failed to fetch merge request count. See exception details for more information.`, error);
                if (!error.message?.includes(STALE_TAB_ERROR_MESSAGE)) {
                    Sentry.captureException(error, SENTRY_OPTIONS);
                }
            }
        },
        openMrs: {
            query: getOpenMrsForBlobPath,
            variables () {
                return this.queryVariables;
            },
            skip () {
                return !this.isDropdownOpen;
            },
            update: (data)=>data?.project?.mergeRequests?.nodes?.map((node)=>({
                        ...node,
                        text: node.title,
                        href: node.webPath
                    })) || [],
            error (error) {
                logError(`Failed to fetch merge requests. See exception details for more information.`, error);
                if (!error.message?.includes(STALE_TAB_ERROR_MESSAGE)) {
                    Sentry.captureException(error, SENTRY_OPTIONS);
                }
            }
        }
    }
};
